<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="ml-2 mr-2">
      <validation-observer ref="interBankTransferRules">
        <b-form
          id="gateway-fee-configuration"
          @submit.prevent="handleSubmit"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <h5 class="section-label mb-2 mt-2">
                {{ $t('Activate / Deactivate Outward Transfers Across All Channels') }}
              </h5>
              <b-row class="match-height">
                <b-col
                  cols="12"
                >
                  <SwitchButton
                    v-if="getUserPermission('ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER')"
                    v-model="interBankTransferFormData.disableFTOutward"
                    :label="$t('Interbank Transfer')"
                    name="enable-interbank-transfer"
                    class="ml-6"
                    :readonly="isReadonly"
                  />
                </b-col>
                <div class="ml-2 mt-2">
                  <Button
                    v-if="getUserPermission('ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER')"
                    :label="$t('Update')"
                    :loading="isLoading"
                    :disabled="isDisabled"
                    size="lg"
                    @click="handleSubmit"
                  />
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol,
  BForm, VBTooltip,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import {
  required, amount, positive,
} from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import SwitchButton from '../../../../components/switch/Switch.vue'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    FullScreenSpinner,
    SwitchButton,
    Button,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      amount,
      positive,
      buttonLabel: this.$t('Activate'),
      interBankTransferFormData: {
        disableFTOutward: true,
      },
    }
  },
  mounted() {
    this.fetchInterBankTransferStatus()
  },
  methods: {
    ...mapActions({
      getInterBankTransferStatus: 'eChannels/getInterBankTransferStatus',
      updateInterBankTransfer: 'eChannels/updateIntitutionGateway',
    }),

    handleSubmit() {
      this.buttonLabel = this.interBankTransferFormData.disableFTOutward ? this.$t('Activate') : this.$t('Deactivate')
      this.$refs.interBankTransferRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const text = this.$t('Interbank Transfer?')
          this.confirm(this.interBankTransferAction, { text: `${areYouSure} ${this.buttonLabel} ${text}` })
        }
      })
    },
    async interBankTransferAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          disableFTOutward: this.interBankTransferFormData.disableFTOutward !== true,
        }
        const response = await this.updateInterBankTransfer({ formData, permission: eChannelsPermission.ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER })

        const { status } = await response
        if (status === 200) {
          this.fetchInterBankTransferStatus()
          const requestText = this.$t('Your request to')
          const successText = this.$t('Interbank Transfer was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${successText}` })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Interbank Transfer failed. Reason')
          const errorMessage = `${requestText} ${this.buttonLabel} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async fetchInterBankTransferStatus() {
      try {
        this.showSpinner = true
        const response = await this.getInterBankTransferStatus({ permission: eChannelsPermission.ENABLE_DISABLE_GENERAL_INTERBANK_TRANSFER })
        const { status, data } = await response
        if (status === 200 && data) {
          this.interBankTransferFormData = {
            disableFTOutward: data.disableFTOutward !== true,
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
